<template>
  <b-container class="page-title">
    <b-row class="text-orange py-2 pt-4">
      <b-col cols="10">
        <div class="user-welcome" style="overflow:hidden">
          <div class="wrapper d-flex">
            <router-link
              class="d-inline-block mr-3 btn btn-sm bg-dark text-primary"
              v-if="backLink"
              :to="backLink"
            >
              <i class="ti-arrow-left mr-1"></i> Back
            </router-link>
            <h4 class="d-inline-block">{{ title }}</h4>
          </div>
        </div>
      </b-col>
      <b-col cols="2" class="text-right"></b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "page-title",
  props: {
    title: null,
    backLink: null
  }
};
</script>

<style>
.d-inline-block.btn.btn-sm {
  height: 33px;
}
</style>
